import React from "react";
import Box from '@mui/material/Box';
import MediaCard from "./MediaCard";
import Image from './fondo4.jpg';

const Cedears = ({mediaData}) => {

  const acciones = [
    {
      ticker:"TGNO4.BA",
      image:"/images/GOOG.png",
      category:"Estructura",
      name:"TGN",
      description: "Alphabet ofrece una enorme cantidad de productos y servicios, pero en líneas generales, divide sus ventas en 3 distintos segmentos: Google Services, Google Cloud y Other Bets. Google Cloud es el segmento más prometedor de Alphabet, y consiste en un conjunto de recursos físicos, como computadoras y unidades de disco duro, y recursos virtuales que se encuentran en los centros de datos de Google en todo el mundo.",
      NetRevenue: 289531000000, NetIncome: 60953000000, Shares: 13135750000, EBIT: 73802000000, FCF: 71094000000, DandA: 14830000000, Equity: 267141000000, Debt: 26451000000, CashandEquivalents: 118332000000
    },
    {
      ticker:"TRAN.BA",
      name:"Transener",
      category:"Estructura",
      image:"/images/MSFT.png",
      description: "Microsoft produce software, productos electrónicos, computadoras personales y servicios relacionados. La empresa desarrolla, fabrica, licencia y da soporte a ordenadores personales, servidores y dispositivos electrónicos. Sus productos más conocidos son el sistema operativo Microsoft Windows y el paquete Microsoft Office. El segmento Azure es uno de los más prometedores de la empresa, es una plataforma de computación en la nube.",
      NetRevenue: 211915000000, NetIncome: 72361000000, Shares: 7472000000, EBIT: 89077000000, FCF: 59475000000, DandA: 13861000000, Equity: 206223000000, Debt: 59965000000, CashandEquivalents: 111262000000
    },
    {
      ticker:"TXAR.BA",
      image:"/images/BAC.png",
      name:"Ternium Arg",
      description: "Es una de las principales instituciones financieras del mundo, ofrece a particulares, pequeñas y grandes empresas una amplia gama de productos y servicios de banca, inversión, gestión de activos y otros productos y servicios financieros y de gestión de riesgos. Cuenta con unos activos de $3.120 billones, representados por más de 48 millones de clientes. Durante el año 2022 tuvo ventas de $95 billiones y ganancias por $27 billones.",
      NetRevenue: 100489000000, NetIncome: 29783000000, Shares: 8143475000, EBIT: "N/A", FCF: 44638000000, DandA: 2006000000, Equity: 254922000000, Debt: 327090000000, CashandEquivalents: 513499000000
    },
    {
      ticker:"CEPU.BA",
      image:"/images/META.png",
      name:"Central Puerto",
      description: "Es un conglomerado estadounidense de tecnología y redes sociales. Es la empresa matriz de Facebook, Instagram, WhatsApp y otras subsidiarias. Últimamente está realizando fuertes inversiones en el metaverso a través de Oculus (empresa que produce dispositivos de realidad virtual). La principal vía de ingresos de la empresa es a través de la venta de anuncios a sus comercializadores.",
      NetRevenue: 120523000000, NetIncome: 22544000000, Shares: 2637250000, EBIT: 28682000000, FCF: 24033000000, DandA: 9698000000, Equity: 134033000000, Debt: 36218000000, CashandEquivalents: 53446000000
    }
  ]

  const myStyle={
    backgroundImage: `url(${Image})`,
    height:"100%",
    marginTop:'0px',
    backgroundSize: 'cover',
    width:"100%",
    backgroundRepeat: 'no-repeat',
    };    
  

  return (
    <>
    <Box style={myStyle} sx={{ 
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center'}}>
      
      {acciones.map((stock) => (
          <MediaCard categoy={stock.category} description={stock.description} name={stock.name} ticker={stock.ticker} image={stock.image} NetRevenue={stock.NetRevenue} NetIncome={stock.NetIncome} Shares={stock.Shares} EBIT={stock.EBIT} FCF={stock.FCF} DandA={stock.DandA} Equity={stock.Equity} Debt={stock.Debt} CashandEquivalents={stock.CashandEquivalents}/>
      ))}

    </Box>
    
    </>
  );
}

export default Cedears;